module.exports = __webpack_public_path__ + "static/img/SketchPngccfcb5002e81197994eba156ab96346fdced149995e328a2a66f01f3c7cafdf0.d1a725d6.png";